'use client';

import React from 'react';

import { Button } from '../button';
import { SpinnerInline } from '../spinner-inline';

export function FormButton({
  children,
  isPending,
  ...props
}: Omit<React.ComponentProps<typeof Button>, 'type' | 'variant'> & {
  type?: React.ComponentProps<typeof Button>['type'];
  variant?: React.ComponentProps<typeof Button>['variant'];
  isPending: boolean;
}) {
  return (
    <Button
      type="submit"
      variant="primary-card"
      disabled={isPending}
      {...props}
    >
      {children}
      {isPending ? <SpinnerInline /> : null}
    </Button>
  );
}
